import { render, staticRenderFns } from "./RotationPic.vue?vue&type=template&id=a4a167e8&scoped=true&"
import script from "./RotationPic.vue?vue&type=script&lang=js&"
export * from "./RotationPic.vue?vue&type=script&lang=js&"
import style0 from "./RotationPic.vue?vue&type=style&index=0&id=a4a167e8&lang=scss&scoped=true&"
import style1 from "./RotationPic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a167e8",
  null
  
)

export default component.exports